import React from 'react';

import { Input } from '@components/index';
import { INPUT_BASE_CLASSNAME } from '@features/lead-management/constants/common';

import { germanyCountryCode } from '../../../../components/country-code/constants';
import CountryCode from '../../../../components/country-code/CountryCode';

interface MobileNumberInputProps {
  label: string;
  isRequired?: boolean;
  countryCode: string;
  phoneNumber: string;
  onPhoneNumberChange: (phoneNumber: string) => void;
  onPhoneNumberBlur?: () => void;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  onCountryCodeChange: (countryCode: string) => void;
}

const MobileNumberInput: React.FC<MobileNumberInputProps> = ({
  label,
  isRequired = false,
  countryCode,
  phoneNumber,
  onPhoneNumberChange,
  onPhoneNumberBlur,
  error = false,
  errorMessage,
  disabled = false,
  placeholder = 'Enter phone number',
  className = '',
  onCountryCodeChange
}) => {
  const getMaxLength = () => (countryCode === germanyCountryCode ? 11 : 10);

  return (
    <div className={className}>
      <div className="mb-2">
        <span className="text-sm font-medium text-gray-700">
          {label}
          {isRequired && <span className="ml-1 text-red-500">*</span>}
        </span>
      </div>

      <div className="flex gap-3">
        <CountryCode
          hasSelection={!disabled}
          setCountryCode={onCountryCodeChange}
          countryCode={countryCode}
          dropdownStyle={`!bg-cofeeNeutral1 ${
            disabled ? '!bg-cofeeGreyBlue100 ' : ''
          }`}
          titleLabelStyle={disabled ? '!text-cofeeNeutral7' : 'text-content'}
        />

        <Input
          disabled={disabled}
          className={`w-full ${error && 'mb-5 2xl:mb-2'}`}
          value={phoneNumber}
          handleInputChange={onPhoneNumberChange}
          placeholder={placeholder}
          type="phone"
          maxLength={getMaxLength()}
          error={error}
          errorMessage={errorMessage}
          errorStyle="bottom-0 2xl:top-13.5 top-16"
          handleInputBlur={onPhoneNumberBlur}
          inputStyle={`${INPUT_BASE_CLASSNAME} ${
            disabled ? '!bg-cofeeGreyBlue100 !text-cofeeNeutral7' : ''
          }`}
        />
      </div>
    </div>
  );
};

export default MobileNumberInput;
